import dayjs from "dayjs";

import Table from "react-bootstrap/Table";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { Gender, genderMessages } from "@/utils/enums/sintegrada/Gender";
import { Discharge } from "@/services/sintegradaserver/discharge/getDischargeSummary";

import { TableSkeletons } from "@/components/TableSkeletons";

import "./styles.scss";

type Props = {
	isLoading: boolean;
	data: Discharge[];
};

export function DischargeIndividualTable({ data, isLoading }: Props) {
	const hasData = Boolean(data?.length);

	return (
		<Table responsive bordered id="discharge-individual-table">
			<thead className="fw-bolder">
				<tr>
					<th>Nome do paciente</th>
					<th>CPF</th>
					<th>Dt. nasc.</th>
					<th>Sexo</th>
					<th>Classificação</th>
					<th>Tipo de alta</th>
					<th>Unidade de transferência</th>
					<th>Data de alta</th>
					<th>Responsável</th>
				</tr>
			</thead>
			<tbody>
				{!isLoading ? (
					hasData ? (
						data?.map((item, index) => {
							const { patient } = item;

							const formattedIdentifier = formatIdentifier(patient.identifier);
							const formattedBirthdate = dayjs(patient.birthday).format("DD/MM/YYYY");
							const formattedGender = genderMessages[patient.sex as Gender] || "N/A";
							const formattedDischargeDate = dayjs(item.discharge_date).format("DD/MM/YYYY");

							return (
								<tr key={`discharge-${index}`}>
									<td>{patient.name}</td>
									<td>{formattedIdentifier}</td>
									<td>{formattedBirthdate}</td>
									<td>{formattedGender}</td>
									<td>{item.risk.name || "N/A"}</td>
									<td>{item.discharge_type}</td>
									<td>{item.transfer_unit_name || "N/A"}</td>
									<td>{formattedDischargeDate}</td>
									<td>{item.professional_name}</td>
								</tr>
							);
						})
					) : (
						<tr>
							<td colSpan={12} className="text-center text-black-50 fw-bold">
								Nenhum resultado encontrado
							</td>
						</tr>
					)
				) : (
					<TableSkeletons numberOfCells={9} numberOfRows={15} height={15} />
				)}
			</tbody>
		</Table>
	);
}
